import frontpage from './modules/frontpage';
import gsap from "gsap";

frontpage();



import initMap from './modules/nearByMap';
const mapDiv = document.querySelector('#map-near-by');
if (mapDiv){
    initMap()
}

import swipers from './modules/swipers';
swipers();

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const primaryButtons = document.querySelectorAll('.js-primary-btn');
if (window.outerWidth > 768) {
    if (primaryButtons) {
        for (const primaryButton of primaryButtons) {
            const tl = gsap.timeline().pause(0);

            primaryButton.addEventListener('mouseenter', () => {
                if (primaryButton.parentElement.disabled) {
                    return false;
                }
                tl.play();
            });

            primaryButton.addEventListener('mouseleave', () => {
                tl.reverse();
            });
        }
    }
}



document.addEventListener('DOMContentLoaded', ()=>{

    const isLandingPage = document.querySelector('.page-template-template-landing-new');
    if (!isLandingPage){
        return;
    }


    const loadingTL = gsap.timeline({
        defaults: {
            ease: "power1.out",
        }
    });

    const letters = document.querySelectorAll('#logoWrapper svg');

    // loadingTL.timeScale(10).play()
    loadingTL
        .fromTo(letters,
            {
                yPercent: -100
            },
            {
                yPercent: 0,
                duration: 0.8,
                stagger: 0.2
            })
        .fromTo('.home-page-sub-title',
            {
                opacity: 0,
                y: 50,
            },
            {
                opacity: 1,
                y: 0,
                duration: 1,
            })
        .fromTo('.home-page-text',
            {
                opacity: 0,
                y: 30,
            },
            {
                opacity: 1,
                duration: 0.6,
                y: 0
            }, ">-0.2")
        .fromTo('.video-wrapper',
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
            }, ">-0.4")


        .fromTo('.country-wrapper',
            {
                opacity: 0,
                y: 20,
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.3
            })
        .fromTo('#awardsBlock',
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 0.5,
            }, ">-0.5")

})


const countryWrappers = document.querySelectorAll('.country-wrapper');

const timeLines = [];
const moveTLs = []

countryWrappers.forEach((countryWrapper, index) => {

    const elementsToMove = Array.from(countryWrappers).slice(0, index);



    const button = countryWrapper.querySelector('.country-button')

    const countryList = countryWrapper.querySelector('.countries-list')

    const cities = countryWrapper.querySelectorAll('.countries-list a');
    const TL = gsap.timeline().pause()
    timeLines[index] = TL;

    // const TLMoveCountries = gsap.timeline().pause()
    // moveTLs[index] = TLMoveCountries;
    //
    //
    // TLMoveCountries
    //     .add(
    //         ()=>{
    //             console.log('countryList ', countryList)
    //             console.log('current item index ', index)
    //             console.log(countryList.clientHeight)
    //
    //             // Calculate elementsToMove dynamically here
    //             const elementsToMove = [...countryWrappers]
    //                 .slice(0, index)
    //                 .filter(wrapper => {
    //                     const currentY = gsap.getProperty(wrapper, "y");
    //                     return currentY === 0 || currentY === "0px";
    //                 });
    //
    //             console.log('elementsToMove ', elementsToMove)
    //
    //             // Only animate if there are elements to move
    //             if (elementsToMove.length > 0) {
    //                 gsap.to(elementsToMove, {
    //                     y: -60, // or whatever height calculation you need
    //                     duration: 0.4
    //                 });
    //
    //             }
    //         }
    //     )


    TL
        .to(countryList, { display: "block", opacity: 1, duration: 0.1 })

        .fromTo(cities,
            {
                opacity:0,
                yPercent: 30
            },
            {
                opacity: 1,
                yPercent: 0,
                stagger: 0.2,
                duration: 0.4
            }, "<")


    button.addEventListener('click', ()=>{
        if (countryWrapper.classList.contains('open')){

            TL.timeScale(1.5).reverse();
            countryWrapper.classList.remove('open')

            countryWrappers.forEach(wrapper=>{
                const currentY = gsap.getProperty(wrapper, "y");

                if (currentY !== 0) {
                    gsap.to(wrapper, {y: 0, duration: 0.3})
                }
            })

        }else{
            // Close others
            timeLines.forEach((timeline, i) => {
                if (i !== index && countryWrappers[i].classList.contains('open')) {
                    timeline.timeScale(1.5).reverse();
                    countryWrappers[i].classList.remove('open');
                }
            });

            // Get height
            gsap.set(countryList, { display: "block", opacity: 0 });
            const height = countryList.clientHeight;
            gsap.set(countryList, { display: "none" });

            // Position animations
            countryWrappers.forEach((wrapper, i) => {
                if (i < index) {
                    gsap.to(wrapper, { y: -height, duration: 0.3 });
                } else {
                    gsap.to(wrapper, { y: 0, duration: 0.3 });
                }
            });

            // Content timeline
            countryWrapper.classList.add('open');
            TL.play()
        }
    })

})

document.addEventListener('click', (e) => {
    const buttonsWrapper = document.querySelector('.buttons-wrapper');

    if (buttonsWrapper && !buttonsWrapper.contains(e.target)) {
        timeLines.forEach((timeline, i) => {
            if (countryWrappers[i].classList.contains('open')) {
                timeline.timeScale(1.5).reverse();
                countryWrappers[i].classList.remove('open');
            }
        });

        countryWrappers.forEach(wrapper=>{
            const currentY = gsap.getProperty(wrapper, "y");

            console.log('currentY ', currentY)
            if (currentY !== 0) {
                gsap.to(wrapper, {y: 0})
            }
        })

    }
});






gsap.utils.toArray('[data-speed]').forEach((item) => {
    const speed = parseFloat(item.dataset.speed) || 1;
    // console.log(speed)
    // Calculate initial offset based on speed and viewport height
    // const offset = (window.innerHeight / 2) * (1 - speed);
    const offset = (window.innerHeight / 2) * (-1 * speed   );
    const initialOffset = (window.innerHeight * (speed - 1)) / 2;
    // console.log(initialOffset)

    // Set initial position below natural spot based on speed
    gsap.set(item, { y: initialOffset });

    // Apply ScrollTrigger to adjust position as you scroll
    gsap.to(item, {
        y: -initialOffset,
        ease: 'none',
        scrollTrigger: {
            trigger: item,
            start: `top-=${initialOffset} bottom`, // Start animation when the item enters the viewport
            end: `bottom-=${initialOffset} top`,   // End when item exits the viewport
            // start: `top+=${offset} bottom`, // Adjust start point dynamically for accurate center alignment
            // end: `bottom-=${offset} top`, // Adjust end point based on offset
            scrub:0.6,         // Smoothly interpolate
            markers: false,
        }
    });
});
